<template>
  <ul class="ml-0">
    <li
      v-for="item in filteredItems"
      :key="item.value"
      class="list-none text-EXPONDO-grey"
    >
      <CheckboxPickerOption
        :refine="refine"
        :checkbox-item="item"
        :facet="facet"
      />
    </li>
  </ul>
</template>

<script lang="ts">

import type { RefinementListItem } from 'vue-instantsearch/vue3/es';

import { CAMPAIGN_INDICATOR } from '~~/constants/commerceTools';

export default defineComponent({
  name: 'CheckboxPicker',

  props: {
    items: {
      type: Array as PropType<RefinementListItem[]>,
      required: true,
    },
    refine: {
      type: Function,
      required: true,
    },
    facet: {
      type: String,
      required: true,
    },
  },
  setup (props) {

    const { isActiveCampaignLabel } = useStoreVsfExtended();

    const filteredItems = computed(() =>
      props.items.filter(item => {

        if (item.value.includes(CAMPAIGN_INDICATOR)) {

          return isActiveCampaignLabel(item.value);
        
        }

        return item;
      
      }),
    );

    return {
      filteredItems,
    };
  
  },
});

</script>
